import React, { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
// import reportWebVitals from "./reportWebVitals";
import AppRouter from "./Components/AppRouter";
// import * as Sentry from "@sentry/react";
// import { onCLS, onFID, onLCP } from "web-vitals";
import "./index.css";
import "react-toastify/dist/ReactToastify.css";
import "./store/toastStyles.css";

import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Clarity from "@microsoft/clarity";

// import { AuthProvider } from "./Services/AuthContext";
// import { LoadingProvider } from "./Services/LoadingContext";
// import store from "./app/store";
// import { Provider } from "react-redux";
const container = document.getElementById("root");
import ReactDOM from "react-dom";
// import MigrationPage from "./Components/Common/MigrationPage";
import isBot from "./utils/isBot";
if (!isBot()) {
    // Sentry.init({
    //     dsn: "https://3d94b76063ff4e2a1a0e0c713639bb7e@o4505849017270272.ingest.us.sentry.io/4508080612048896",
    //     // enabled in production only
    //     enabled: process.env.NODE_ENV === "production",
    //     integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],

    //     // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    //     replaysOnErrorSampleRate: 0.5,

    //     // Session Replay
    //     replaysSessionSampleRate: 0.3,

    //     //  Capture 100% of the transactions
    //     // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    //     tracePropagationTargets: [
    //         // "localhost",
    //         "bidcoin.live",
    //         // "api.bidcoin.live",
    //         // "test.bidcoin.live",
    //         // "testing.bidcoin.live",
    //     ],

    //     // Tracing
    //     tracesSampleRate: 0.5, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    //     maskAllText: false,
    //     maskAllInputs: false,
    //     blockAllMedia: false,
    //     unblock: [".sentry-unblock, [data-sentry-unblock]"],
    //     unmask: [".sentry-unmask, [data-sentry-unmask]"],
    // });
    // onCLS(console.log);
    // onFID(console.log);
    // onLCP(console.log);
    const projectId = "q6d7d7p7fy";
    Clarity.init(projectId);
}
// import LanguageDetector from "i18next-browser-languagedetector";
/**
 * To load translations from JSON files located in the src/assets/locales directory, you can use the i18next-http-backend package. This package allows you to load translations from external files. Here's how you can modify your src/i18n.js file to use this backend:
 * pnpm install i18next-http-backend
 * Explanation:
Backend: The i18next-http-backend is used to load translation files from a specified path. The loadPath option specifies where to find the translation files. The {{lng}} placeholder will be replaced with the current language code (e.g., en, es, etc.).
Fallback Language: The fallbackLng is set to "en", which means if a translation is not found for the current language, it will fall back to English.
Debug: The debug option is set to true to help you see what's happening during the initialization and loading process. You can set it to false in production.
Interpolation: The escapeValue is set to false because React already handles XSS protection.
This setup will automatically load the appropriate translation file based on the current language setting. Make sure your server is configured to serve static files from the src/assets directory.
 */
const resources = {
    en: {
        translation: require("./assets/locales/en/translation.json"),
    },
    fr: {
        translation: require("./assets/locales/fr/translation.json"),
    },
};

i18n.use(initReactI18next)
    // .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        // backend: {
        //     loadPath: "public/locales/{{lng}}/translation.json",
        // },
        resources: resources,
        lng: "en", // if you're using a language detector, do not define the lng option
        fallbackLng: "en",
        useSuspense: false,
        debug: false,
        interpolation: {
            escapeValue: false, // react already safes from xss
        },
    });
const root = createRoot(
    container,

    {
        // Callback called when an error is thrown and not caught by an Error Boundary.
        // onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
        //     console.warn("Uncaught error", error, errorInfo.componentStack);
        // }),
        // // Callback called when React catches an error in an Error Boundary.
        // onCaughtError: Sentry.reactErrorHandler(),
        // // Callback called when React automatically recovers from errors.
        // onRecoverableError: Sentry.reactErrorHandler(),
    }
);
root.render(
    <StrictMode>
        <BrowserRouter>
            <AppRouter />
            {/* <MigrationPage /> */}
        </BrowserRouter>
    </StrictMode>
);

// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// // reportWebVitals();
